import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'

export default defineNuxtRouteMiddleware((to, from) => {
  const nuxtApp = useNuxtApp()
  const { $pinia } = nuxtApp
  const affiliateCustomizationStore = useAffiliateCustomizationStore($pinia)

  if (!affiliateCustomizationStore.isSupportedPage(to)) {
    return nuxtApp.runWithContext(() => navigateTo('/404'))
  }
});
